export default __webpack_public_path__ + "static/media/TokiRGB_skyBlue.9cd32389.png";